export default __webpack_public_path__ + "static/la-sala-balthazaurus-scroll-5cbf154b6e605e77c8778cf7b8600c57.gif";